import { createSelector, createFeatureSelector } from '@ngrx/store';
import { ServiceInventoryState } from './service-inventory.model';

export const selectServiceInventoryState = createFeatureSelector<ServiceInventoryState>('serviceInventory');
export const selectAllServices = createSelector(
  selectServiceInventoryState,
  (state) => Object.values(state.items)
);
export const selectServiceByKey = (key: string) => createSelector(
  selectServiceInventoryState,
  (state) => {
    return state.items[key] || null;
  }
);
export const selectLoadingState = createSelector(
  selectServiceInventoryState,
  (state) => state.loading
);
